import { NumberFormat } from 'entities/TableControllers/entities/number';

import { getNumberLocale } from './locale';
import { toHumanReadableFormat } from './toHumanReadableFormat';

export const NORMALIZE_NUMBER: Record<NumberFormat, (raw: number) => number> = {
  [NumberFormat.percent]: (raw) => {
    return Number((raw * 100).toFixed(3));
  },
  [NumberFormat.default]: (raw) => {
    return raw;
  },
};

export const DENORMALIZE_NUMBER: Record<NumberFormat, (display: number) => number> = {
  [NumberFormat.percent]: (display) => {
    return display / 100;
  },
  [NumberFormat.default]: (display) => {
    return display;
  },
};

export const formatNumberControllerValue = ({
  value,
  format,
}: {
  value: number | null;
  format: NumberFormat;
}): string => {
  if (value === null) {
    return '';
  }

  switch (format) {
    case NumberFormat.percent:
      return `${new Intl.NumberFormat(getNumberLocale()).format(value)}%`;
    default:
      return toHumanReadableFormat(value);
  }
};
